export const staticImai = () => ({
  id: "imei",
  name: "IMEI",
  // selector: "imei",
  minWidth: "200px",
  key: "imei",

  cell: (row) => <span>{row?.imei}</span>
});
